import React, { useEffect, useState } from 'react';
import { useAuthState, useAuth } from '../hooks/useAuth';
import { profileAPI } from '../services/api';
import { ThemeContext } from './themeContext';

export const ThemeProvider = ({ children }) => {
  const { user } = useAuthState();
  const { updateUser } = useAuth();
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    // Only update from user.theme if localStorage doesn't have a value
    if (!savedTheme && user?.theme) {
      setTheme(user.theme);
    }
  }, [user?.theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = async () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    
    if (user) {
      try {
        await profileAPI.updateProfile(undefined, newTheme);
        updateUser({ theme: newTheme });
      } catch (error) {
        console.error('Failed to save theme preference:', error);
      }
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};